import React, {useEffect, useState} from 'react';
import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TechnicalMapJobCard from './TechnicalMapJobCard';
import {
    technicalMapCardSectionTitleSx,
    technicalMapGroupBodySx,
    technicalMapGroupContainerSx,
    technicalMapGroupHeaderSx,
} from './technicalMapCardStyles';

const TechnicalMapJobCardGroup = ({
                                      typeJobName,
                                      jobs,
                                      expandAll,
                                      expandAllRevision,
                                      setData,
                                      handleModalAlert,
                                      isSettingsRole,
                                      isActionActive,
                                      onExecuteJob,
                                      onCancelExecuteJob,
                                      onDeleteJob,
                                      expandedWorkersByJobId,
                                      setWorkersExpanded,
                                      toggleWorkersExpanded,
                                  }) => {
    const [expanded, setExpanded] = useState(true);

    useEffect(() => {
        if (expandAllRevision > 0) {
            setExpanded(expandAll);
        }
    }, [expandAllRevision, expandAll]);

    return (
        <Box sx={technicalMapGroupContainerSx}>
            <Box
                onClick={() => setExpanded((prev) => !prev)}
                sx={technicalMapGroupHeaderSx}
            >
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <Typography sx={{...technicalMapCardSectionTitleSx, flex: 1, minWidth: 0}}>
                        {typeJobName}
                    </Typography>
                </Box>
                <Typography sx={{fontSize: '14px', color: 'text.secondary', flexShrink: 0}}>
                    {jobs.length}
                </Typography>
                <ExpandMoreIcon
                    sx={{
                        flexShrink: 0,
                        fontSize: 28,
                        color: 'text.secondary',
                        transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease',
                    }}
                />
            </Box>

            {expanded && (
                <Box sx={technicalMapGroupBodySx}>
                    {jobs.map((job) => (
                        <TechnicalMapJobCard
                            key={job.id}
                            job={job}
                            isGrouped
                            workersExpanded={Boolean(expandedWorkersByJobId?.[String(job.id)])}
                            toggleWorkersExpanded={toggleWorkersExpanded}
                            setWorkersExpanded={setWorkersExpanded}
                            setData={setData}
                            handleModalAlert={handleModalAlert}
                            isSettingsRole={isSettingsRole}
                            isActionActive={isActionActive}
                            onExecuteJob={onExecuteJob}
                            onCancelExecuteJob={onCancelExecuteJob}
                            onDeleteJob={onDeleteJob}
                        />
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default TechnicalMapJobCardGroup;
